import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import { EmailInput, NameInput } from './inputs';
import {
    PhoneNumberInput,
    PhoneNumberInputWithValidation,
} from '../common/inputs/phone-number';

class IncompleteForm extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        email: PropTypes.string.isRequired,
        onEmailChange: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        onNameChange: PropTypes.func.isRequired,
        phone_number: PropTypes.string.isRequired,
        onPhoneNumberChange: PropTypes.func.isRequired,
        phone_number_country: PropTypes.string.isRequired,
        onPhoneNumberCountryChange: PropTypes.func.isRequired,
    };

    getEmailInputContainerRef = () => this.email_input_container_ref;

    onNameInputKeyUp = e =>
        e.key === 'Enter' &&
        this.phone_number_input_ref &&
        this.phone_number_input_ref.focus();

    focusOnEmailInput() {
        if (this.email_input_ref) {
            this.email_input_ref.focus();
        }
    }

    render() {
        const {
            t,
            email,
            onEmailChange,
            name,
            onNameChange,
            phone_number,
            onPhoneNumberChange,
            phone_number_country,
            onPhoneNumberCountryChange,
        } = this.props;
        const { customer_phone_number_validation_enabled } = Mobi2Go.headoffice;

        return (
            <div>
                <EmailInput
                    value={email}
                    onChange={onEmailChange}
                    ref={ref => {
                        this.email_input_ref = ref;
                    }}
                    containerRef={ref => {
                        this.email_input_container_ref = ref;
                    }}
                />
                <NameInput
                    value={name}
                    onChange={onNameChange}
                    onKeyUp={this.onNameInputKeyUp}
                    containerRef={ref => {
                        this.name_input_container_ref = ref;
                    }}
                    ref={ref => {
                        this.name_input_ref = ref;
                    }}
                />
                {customer_phone_number_validation_enabled ? (
                    <PhoneNumberInputWithValidation
                        value={phone_number}
                        country={phone_number_country}
                        placeholder={t('phone_placeholder')}
                        onChange={onPhoneNumberChange}
                        onCountryChange={onPhoneNumberCountryChange}
                        containerRef={ref => {
                            this.phone_number_input_container_ref = ref;
                        }}
                        ref={ref => {
                            this.phone_number_input_ref = ref;
                        }}
                        containerClassName="m2g-customer-phone-input-container m2g-form-element--full-width"
                        className="m2g-customer-phone-input m2g-form-element--full-width"
                    />
                ) : (
                    <PhoneNumberInput
                        value={phone_number}
                        placeholder={t('phone_placeholder')}
                        onChange={onPhoneNumberChange}
                        containerRef={ref => {
                            this.phone_number_input_container_ref = ref;
                        }}
                        ref={ref => {
                            this.phone_number_input_ref = ref;
                        }}
                        containerClassName="m2g-customer-phone-input-container m2g-form-element--full-width"
                        className="m2g-customer-phone-input m2g-form-element--full-width"
                    />
                )}
            </div>
        );
    }
}

export default forwardRefWithTranslation('customer')(IncompleteForm);
